import Network from "../../utils/Network";

const networkInstance = new Network();
export default networkInstance;
